import { all, takeEvery, put, fork, call, select } from "redux-saga/effects";
import { setMaster, masterContants } from "views/app-views/master/redux";
import { warehouseContants } from "./Constants";
import { WarehouseServices } from "services";

export function* getAllWarehouseSaga() {
  yield takeEvery(
    [masterContants.GET_ALL_MASTER, warehouseContants.GET_ALL_WAREHOUSE],
    function* ({ payload }) {
      try {
        const getCurrentUser = (state) => state.user;
        const { currentUser } = yield select(getCurrentUser);

        const reqBody = {
          limit: 999999999999,
          offset: 0,
          branchId: currentUser.employee.branchId,
        };
        const { data } = yield call(WarehouseServices.getAll, reqBody);
        yield put(setMaster({ warehouses: [...data.rows] }));
      } catch (error) {
        console.log("getAllWarehouseSaga ", error);
      }
    },
  );
}

export default function* rootSaga() {
  yield all([fork(getAllWarehouseSaga)]);
}
